require('../../modules/es6.math.atanh');
module.exports = require('../../modules/_core').Math.atanh;



//////////////////
// WEBPACK FOOTER
// ./~/core-js/library/fn/math/atanh.js
// module id = 1420
// module chunks = 2